import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import auth from './auth'
import profile from './profile'
import documents from './documents'
import Messaging from './messaging'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    profile,
    documents,
    Messaging,
  },
  strict: process.env.DEV,
})
